import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  RaisedButton,
  TextField,
  Toggle,
  Card,
  CardHeader,
  CardText,
  Chip,
  Avatar,
  IconButton,
  SelectField,
  MenuItem,
  AutoComplete
} from "material-ui";
import _ from "lodash";
import { connect } from "react-redux";
import Check from "material-ui/svg-icons/navigation/check";
import Add from "material-ui/svg-icons/content/add";
import Cancel from "material-ui/svg-icons/navigation/cancel";
import Drafted from "material-ui/svg-icons/communication/email";
import Booked from "material-ui/svg-icons/notification/confirmation-number";
import Cancelled from "material-ui/svg-icons/content/block";
import ArrowDropDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import ArrowDropUp from "material-ui/svg-icons/navigation/arrow-drop-up";
import PropTypes from "prop-types";
import { commitMutation, graphql } from "react-relay";
import { StyleSheet } from "aphrodite";

import OurismanTravelTheme from "../../ourismanTravelTheme";
import VIPLetter from "./VIPLetter";
import NoteListItem from "../Trips/NoteListItem";
import environment from "../../relay/environment";

const defaultTransfersMessages = {
  known:
    "The guests will be managing their own transfers; " +
    "for your reference, their flight details are:",
  unknown:
    "Unfortunately, we do not have the guests' travel details " +
    "available; we will be sure to forward you any information that comes " +
    "our way!"
};

const SegmentListItem = ({ segment, segmentId, tripId }) => {
  if (segment.cancelled) {
    return <span style={styles.cancelledSegment}>{segment.name}</span>;
  } else if (segment.id === segmentId) {
    return <b>{segment.name}</b>;
  }

  return (
    <Link to={`/trips/${tripId}/segments/${segment.id}/`}>{segment.name}</Link>
  );
};

SegmentListItem.propTypes = {
  segment: PropTypes.shape().isRequired,
  segmentId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired
};

@connect(state => ({
  viewport: state.Responsive.get("viewport"),
  windowWidth: state.Responsive.get("windowWidth"),
  windowHeight: state.Responsive.get("windowHeight")
}))
class SegmentDetail extends React.Component {
  static propTypes = {
    segment: PropTypes.shape().isRequired,
    users: PropTypes.shape().isRequired
  };

  constructor(props) {
    super(props);

    this.state = this.getInitialState(props);
  }

  componentWillReceiveProps(nextProps) {
    const {
      segment: { id: oldId }
    } = this.props;
    const {
      segment: { id: newId }
    } = nextProps;

    if (oldId !== newId) {
      this.setState(this.getInitialState(nextProps));
    }
  }

  getInitialState = props => {
    const {
      segment: {
        vipContext,
        trip: { travelers, insideCircle },
        amenityProgram = "Virtuoso",
        vendor: { contacts: rawContacts }
      }
    } = props;

    let rightColumnWidth = 0;
    let letterOffset = 0;
    let letterHeight = 0;
    if (this.state !== undefined) {
      rightColumnWidth = this.state.rightColumnWidth;
      letterOffset = this.state.letterOffset;
      letterHeight = this.state.letterHeight;
    }

    const contacts = JSON.parse(rawContacts);
    const primaryContact = _.find(
      contacts,
      contact => contact.primary === true
    );

    let name = "";
    let email = "";
    let position = "";
    let displayName = "";
    if (primaryContact) {
      name = primaryContact.name;
      email = primaryContact.email;
      position = primaryContact.position;
      displayName = primaryContact.displayName || "";
    }

    let additionalContacts = [];
    if (contacts) {
      additionalContacts = contacts
        .filter(contact => contact.primary !== true)
        .map(contact => contact.email);
    }

    const newState = _.assign(
      {
        primaryContactName: name,
        primaryContactDisplayName: displayName,
        primaryContactEmail: email,
        primaryContactPosition: position,
        additionalContactEmails: additionalContacts,
        amenityProgram,
        specialRequests: [],
        transferArrangements: defaultTransfersMessages.unknown,
        arrivalDetails: "",
        departureDetails: "",
        bookingIATA: "Brownell",
        segmentTravelers: {},
        from: this.getDefaultFrom(insideCircle),
        isDirty: false,
        rightColumnWidth,
        letterOffset,
        formExpanded: true,
        letterHeight,
        newRequest: "",
        knownTransfers: false,
        insideCircle
      },
      JSON.parse(vipContext)
    );

    travelers.map(
      ({ id, fullName, firstName, lastName, birthdate, adult, vipNotes }) => {
        // eslint-disable-line
        const existing = newState.segmentTravelers[id];

        const travelerObject = {};
        travelerObject[id] = {
          id,
          fullName,
          firstName,
          lastName,
          birthdate,
          adult,
          traveling: existing === undefined ? true : existing.traveling,
          vipNotes
        };

        newState.segmentTravelers = _.assign(
          newState.segmentTravelers,
          travelerObject
        );
      }
    );

    return newState;
  };

  getDefaultFrom = insideCircle =>
    insideCircle
      ? "Team Ourisman (on behalf of David Ourisman)"
      : "Team Ourisman";

  save = () => {
    const {
      segment: { id: segmentId }
    } = this.props;
    const {
      primaryContactName,
      primaryContactEmail,
      primaryContactPosition,
      additionalContactEmails,
      amenityProgram,
      specialRequests,
      transferArrangements,
      arrivalDetails,
      departureDetails,
      bookingIATA,
      segmentTravelers,
      from,
      knownTransfers,
      insideCircle,
      primaryContactDisplayName
    } = this.state;
    const vipContext = {
      primaryContactName,
      primaryContactEmail,
      primaryContactPosition,
      additionalContactEmails,
      amenityProgram,
      specialRequests,
      transferArrangements,
      arrivalDetails,
      departureDetails,
      bookingIATA,
      segmentTravelers,
      from,
      knownTransfers,
      insideCircle,
      primaryContactDisplayName
    };

    const input = { segmentId, vipContext };

    commitMutation(environment, {
      mutation: graphql`
        mutation SegmentDetail_UpdateVIPLetter_Mutation(
          $input: UpdateVIPLetterInput!
        ) {
          updateVipLetter(input: $input) {
            segment {
              id
            }
          }
        }
      `,
      variables: { input },
      onCompleted: () => {
        this.setState({
          isDirty: false,
          formExpanded: false
        });
      },
      onError: err => alert(err)
    });
  };

  setCheckbox = () => {
    const {
      segment: { id: segmentId, vipDrafted }
    } = this.props;

    const input = {
      segmentId,
      checkbox: "vipDrafted",
      value: !vipDrafted
    };

    commitMutation(environment, {
      mutation: graphql`
        mutation SegmentDetail_SetCheckbox_Mutation($input: SetCheckboxInput!) {
          setCheckbox(input: $input) {
            segment {
              vipDrafted
              trip {
                id
                draftVip
                history {
                  user {
                    firstName
                    lastName
                  }
                  comment
                  dateCreated
                }
              }
            }
          }
        }
      `,
      variables: { input },
      onError: err => alert(err)
    });
  };

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleUnload);
    window.addEventListener("resize", this.handleResize);

    this.setRightColumnWidth();
  }

  handleResize = () => {
    this.setRightColumnWidth();
    this.setLetterOffset();
  };

  setRightColumnWidth = () => {
    const { innerWidth } = window;
    const rightColumnWidth = innerWidth - 530;
    this.setState({ rightColumnWidth });
  };

  getLetterOffset = () => {
    const element = document.getElementById("form");
    return element.offsetTop + element.clientHeight + 15;
  };

  setLetterOffset = () => {
    const { innerHeight } = window;
    const letterOffset = this.getLetterOffset();

    this.setState({
      letterOffset,
      letterHeight: innerHeight - letterOffset - 15
    });
  };

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleUnload);
    window.removeEventListener("resize", this.handleResize);
  }

  handleUnload = e => {
    const { isDirty } = this.state;
    const event = e || window.event;

    if (!isDirty) {
      return undefined;
    }

    const message =
      "You have unsaved changes in your VIP letter, " +
      "leaving without saving will cause them to be lost.";

    event.preventDefault();
    event.returnValue = message;
    return message;
  };

  updateTextField = (field, dirty = true) => e => {
    const {
      target: { value }
    } = e;

    const newState = {
      isDirty: dirty
    };
    newState[field] = value;

    if (field === "primaryContactName") {
      newState.primaryContactDisplayName = value.split(" ")[0];
    }

    this.setState(newState);
  };

  updateRequest = index => ({ target: { value } }) => {
    const { specialRequests } = this.state;
    const newSpecialRequests = [...specialRequests];
    newSpecialRequests[index] = value;

    this.setState({
      isDirty: true,
      specialRequests: newSpecialRequests
    });
  };

  updateEmailList = e => {
    const {
      target: { value }
    } = e;
    const emailList = value.split(",").map(email => email.trim());

    this.setState({
      isDirty: true,
      additionalContactEmails: emailList
    });
  };

  toggleTraveler = id => () => {
    const { segmentTravelers } = this.state;
    segmentTravelers[id].traveling = !segmentTravelers[id].traveling;
    this.setState({
      isDirty: true,
      segmentTravelers
    });
  };

  handleExpandChange = expanded => {
    this.setState({ formExpanded: expanded });
  };

  componentDidUpdate(prevProps, prevState) {
    const newLetterOffset = this.getLetterOffset();
    if (newLetterOffset !== prevState.letterOffset) {
      this.setLetterOffset();
    }
  }

  addRequest = () => {
    const { specialRequests, newRequest } = this.state;
    this.setState({
      isDirty: true,
      newRequest: "",
      specialRequests: [...specialRequests, newRequest]
    });
  };

  removeRequest = index => () => {
    const { specialRequests } = this.state;
    specialRequests.splice(index, 1);
    this.setState({
      isDirty: true,
      specialRequests
    });
  };

  newRequestKeyDown = e => {
    const { keyCode } = e;
    if (keyCode === 13) {
      this.addRequest();
    }
  };

  selectIATA = (event, index, value) => this.setState({ bookingIATA: value });

  toggleKnownTransfers = ({ target: { checked } }) => {
    this.setState({
      isDirty: true,
      knownTransfers: checked,
      transferArrangements: checked
        ? defaultTransfersMessages.known
        : defaultTransfersMessages.unknown,
      arrivalDetails: "",
      departureDetails: ""
    });
  };

  toggleInsideCircle = ({ target: { checked } }) => {
    this.setState({
      isDirty: true,
      insideCircle: checked,
      from: this.getDefaultFrom(checked)
    });
  };

  fromOnNewRequest = chosenRequest => {
    this.setState({
      isDirty: true,
      from: chosenRequest
    });
  };

  fromOnUpdateInput = searchText => {
    this.setState({
      isDirty: true,
      from: searchText
    });
  };

  amenityOnNewRequest = chosenRequest => {
    this.setState({
      isDirty: true,
      amenityProgram: chosenRequest
    });
  };

  amenityOnUpdateInput = searchText => {
    this.setState({
      isDirty: true,
      amenityProgram: searchText
    });
  };

  autoCompleteFilter = (searchText, key) => {
    const normalKey = key.toLowerCase();
    const normalText = searchText.toLowerCase();
    return searchText !== "" && normalKey.indexOf(normalText) !== -1;
  };

  moveUp = index => () => {
    if (index > 0) {
      this.moveItem(index, index - 1);
    }
  };

  moveDown = index => () => {
    if (index < this.state.specialRequests.length - 1) {
      this.moveItem(index, index + 1);
    }
  };

  moveItem = (oldIndex, newIndex) => {
    const { specialRequests } = this.state;
    const newRequests = specialRequests.slice();
    const toMove = specialRequests[oldIndex];
    newRequests.splice(oldIndex, 1);
    newRequests.splice(newIndex, 0, toMove);
    this.setState({ specialRequests: newRequests });
  };

  render() {
    const {
      segment: {
        trip: {
          notes: tripNotes,
          primaryTravelerName,
          destination,
          id: tripId,
          segments,
          inbox,
          dateString: tripDateString,
          vipNotes: tripVipNotes
        },
        name: segmentName,
        notes: segmentNotes,
        startDate,
        endDate,
        category,
        confirmationNumber,
        vendor: { name: vendorName, amenityPrograms },
        id: segmentId,
        vipDrafted,
        dateString,
        bedType
      }
    } = this.props;
    const {
      primaryContactName,
      primaryContactEmail,
      primaryContactPosition,
      additionalContactEmails,
      specialRequests,
      transferArrangements,
      arrivalDetails,
      departureDetails,
      bookingIATA,
      segmentTravelers,
      isDirty,
      rightColumnWidth,
      formExpanded,
      letterOffset,
      letterHeight,
      newRequest,
      knownTransfers,
      from,
      insideCircle,
      primaryContactDisplayName
    } = this.state;
    const displayEmailList = additionalContactEmails.join(", ");
    const amenityProgram =
      this.state.amenityProgram === "(no program)"
        ? "VIP"
        : this.state.amenityProgram;

    const users = this.props.users.edges.map(edge => edge.node.firstName);
    const autocompleteNames = [
      ...users,
      this.getDefaultFrom(insideCircle)
    ].sort();

    const iatas = {
      Brownell: "01739080",
      Tzell: "01575781"
    };
    const iata = iatas[bookingIATA];

    const dateFormat = "dddd, MMMM Do";
    const displayStartDate = moment(startDate).format(dateFormat);
    const displayEndDate = moment(endDate).format(dateFormat);

    const travelers = _.values(segmentTravelers).filter(
      traveler => traveler.traveling
    );
    const travelerNames = travelers.map(
      ({ firstName, lastName, birthdate, adult }, index) => {
        let age;
        if (adult) {
          age = "";
        } else if (birthdate) {
          age = ` (${moment().diff(moment(birthdate), "years")})`;
        } else {
          age = " (child)";
        }

        let extra = "";
        if (travelers.length < 2) {
          extra = "";
        } else if (travelers.length === 2 && index !== 1) {
          extra = " and ";
        } else if (
          index + 2 !== travelers.length &&
          index + 1 !== travelers.length
        ) {
          extra = ", ";
        } else if (index === travelers.length - 2) {
          extra = ", and ";
        }
        const travelerName = `${firstName} ${lastName}${age || ""}${extra}`;

        return (
          <span key={index}>
            <span style={styles.travelerName}>{travelerName}</span>
          </span>
        );
      }
    );
    const rightColumnStyles = {
      ...styles.rightColumn,
      width: rightColumnWidth
    };
    const formStyles = {
      ...styles.form,
      width: rightColumnWidth
    };
    const renderedLetterStyles = {
      ...styles.renderedLetter,
      width: rightColumnWidth,
      top: letterOffset,
      maxHeight: letterHeight
    };

    const numTravelers = _.values(segmentTravelers).filter(
      traveler => traveler.traveling
    ).length;

    const exampleArrival =
      "XXX (airport code) at 2:15 pm on " +
      `${displayStartDate} via American Airlines Flight #12345`;

    const exampleDeparture =
      "XXX (airport code) at 2:15 pm on " +
      `${displayEndDate} via American Airlines Flight #12345`;

    const cancelledIconColor = OurismanTravelTheme.palette.accent1Color;

    const vipLetterProps = {
      primaryContactDisplayName,
      amenityProgram,
      vendorName,
      from,
      travelerNames,
      displayStartDate,
      displayEndDate,
      category,
      bedType,
      confirmationNumber,
      specialRequests,
      transferArrangements,
      arrivalDetails,
      departureDetails,
      insideCircle,
      iata
    };

    const to = `${primaryContactName} <${primaryContactEmail}>`;
    const cc = displayEmailList;
    const subjectLine = `${amenityProgram} Client Arrival ${dateString} ${vendorName}`.trim();

    const fromInbox = inbox === "insidecircle@" ? "insidecircle@" : "team@";
    const gmailLink =
      "https://mail.google.com/mail/u/" +
      `${fromInbox}metaphortravel.com/?view=cm&fs=1&su=${subjectLine}` +
      `&to=${to}&cc=${cc}`;

    return (
      <div style={styles.container}>
        <div style={styles.leftColumn}>
          <div style={styles.tripDetails}>
            <h2>{segmentName}</h2>
            <Link to={`/trips/${tripId}/`}>
              <h3>
                {primaryTravelerName} {destination} {tripDateString}
              </h3>
            </Link>
            <ol>
              {segments.map(segment => (
                <li key={segment.id} style={styles.segmentListItem}>
                  <SegmentListItem
                    segment={segment}
                    segmentId={segmentId}
                    tripId={tripId}
                  />
                  <div style={styles.segmentIconStyle}>
                    <div style={styles.indicatorGroupStyle}>
                      <div style={styles.indicatorStyle}>
                        {(segment.cancelled && (
                          <Cancelled
                            color={
                              segment.cancelled ? cancelledIconColor : null
                            }
                          />
                        )) ||
                          (!segment.booked && <Booked />) ||
                          null}

                        <span>{segment.cancelled ? "cancelled" : "book"}</span>
                      </div>
                      <div style={styles.indicatorStyle}>
                        {!segment.vipDrafted && !segment.cancelled ? (
                          <Drafted
                            color={
                              segment.cancelled ? cancelledIconColor : null
                            }
                          />
                        ) : null}
                        <span>draft</span>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
          <div style={styles.notesContainer}>
            <h4>VIP Notes for Trip</h4>
            <Card className={newCss(aphroditeStyles.vipNotes)}>
              <CardText>
                {/* eslint-disable react/no-danger */}
                <div
                  className={newCss(aphroditeStyles.display)}
                  dangerouslySetInnerHTML={{ __html: tripVipNotes }}
                />
                {/* eslint-enable react/no-danger */}
              </CardText>
            </Card>
            <h4>VIP Notes for Travelers</h4>
            {travelers.map(traveler => (
              <Card
                key={traveler.id}
                className={newCss(aphroditeStyles.vipNotes)}
              >
                <CardText>
                  <Link to={`/clients/${traveler.id}/`} target="_blank">
                    <h5>{traveler.fullName}</h5>
                  </Link>
                  {/* eslint-disable react/no-danger */}
                  <div
                    className={newCss(aphroditeStyles.display)}
                    dangerouslySetInnerHTML={{ __html: traveler.vipNotes }}
                  />
                  {/* eslint-enable react/no-danger */}
                </CardText>
              </Card>
            ))}
            <h4>Trip Notes</h4>
            {tripNotes.map((note, index) => (
              <NoteListItem key={index} index={index} note={note} />
            ))}
            <h4>Segment Notes</h4>
            {segmentNotes.map((note, index) => (
              <NoteListItem key={index} index={index} note={note} />
            ))}
          </div>
        </div>
        <div style={rightColumnStyles}>
          <Card
            style={formStyles}
            id="form"
            expanded={formExpanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="VIP Letter Form"
              actAsExpander
              showExpandableButton
            />
            <CardText expandable>
              <div style={styles.formRow}>
                <AutoComplete
                  floatingLabelText="Amenity Program"
                  menuStyle={{ width: 500 }}
                  listStyle={{ width: 500 }}
                  dataSource={amenityPrograms}
                  onUpdateInput={this.amenityOnUpdateInput}
                  onNewRequest={this.amenityOnNewRequest}
                  searchText={amenityProgram}
                  filter={this.autoCompleteFilter}
                />
                <SelectField
                  floatingLabelText="Booking IATA"
                  value={bookingIATA}
                  onChange={this.selectIATA}
                >
                  {_.toPairs(iatas).map(pair => (
                    <MenuItem
                      key={pair[1]}
                      value={pair[0]}
                      primaryText={`${pair[0]} #${pair[1]}`}
                    />
                  ))}
                </SelectField>
                <AutoComplete
                  floatingLabelText="Email From"
                  menuStyle={{ width: 500 }}
                  listStyle={{ width: 500 }}
                  dataSource={autocompleteNames}
                  onUpdateInput={this.fromOnUpdateInput}
                  onNewRequest={this.fromOnNewRequest}
                  searchText={from}
                  filter={this.autoCompleteFilter}
                />
                <Toggle
                  toggled={insideCircle}
                  label="Inside Circle"
                  labelPosition="right"
                  onClick={this.toggleInsideCircle}
                />
              </div>
              <div style={styles.formRow}>
                <TextField
                  floatingLabelText="Primary Contact Email"
                  value={primaryContactEmail}
                  onChange={this.updateTextField("primaryContactEmail")}
                />
                <TextField
                  floatingLabelText="Primary Contact Name"
                  value={primaryContactName}
                  onChange={this.updateTextField("primaryContactName")}
                />
                <TextField
                  floatingLabelText="Primary Contact Display Name"
                  value={primaryContactDisplayName}
                  onChange={this.updateTextField("primaryContactDisplayName")}
                />
                <TextField
                  floatingLabelText="Primary Contact Position"
                  value={primaryContactPosition}
                  onChange={this.updateTextField("primaryContactPosition")}
                />
              </div>
              <div style={styles.formRow}>
                <TextField
                  floatingLabelText="Additional Contact Emails (comma-separated list)"
                  value={displayEmailList}
                  onChange={this.updateEmailList}
                  fullWidth
                />
              </div>
              <div style={styles.travelerRow}>
                <h4>Travelers for Segment ({numTravelers} selected)</h4>
                <div style={styles.travelerChips}>
                  {_.values(segmentTravelers).map(
                    ({ id, fullName, traveling, birthdate, adult }) => {
                      const age =
                        (birthdate &&
                          moment().diff(moment(birthdate), "years")) ||
                        (adult && "18+") ||
                        "child";

                      return (
                        <Chip
                          key={id}
                          style={styles.chip}
                          onTouchTap={this.toggleTraveler(id)}
                          onRequestDelete={
                            traveling ? this.toggleTraveler(id) : null
                          }
                        >
                          {traveling ? (
                            <Avatar color="#444" icon={<Check />} />
                          ) : null}
                          {fullName} ({age})
                        </Chip>
                      );
                    }
                  )}
                </div>
              </div>
              <div>
                <h4>Special Requests or Occasions</h4>
                <ul>
                  {specialRequests.map((request, index) => (
                    <li key={index} style={styles.formRequest}>
                      <TextField
                        id={`${index}`}
                        value={request}
                        fullWidth
                        onChange={this.updateRequest(index)}
                      />
                      <IconButton
                        style={styles.buttonStyle}
                        onTouchTap={this.moveUp(index)}
                        disabled={index < 1}
                      >
                        <ArrowDropUp />
                      </IconButton>
                      <IconButton
                        style={styles.buttonStyle}
                        onTouchTap={this.moveDown(index)}
                        disabled={index >= specialRequests.length - 1}
                      >
                        <ArrowDropDown />
                      </IconButton>
                      <IconButton>
                        <Cancel onClick={this.removeRequest(index)} />
                      </IconButton>
                    </li>
                  ))}
                </ul>
                <div style={styles.newRequest}>
                  <TextField
                    hintText="e.g. The family enjoys fruit and water"
                    fullWidth
                    value={newRequest}
                    onChange={this.updateTextField("newRequest", false)}
                    onKeyDown={this.newRequestKeyDown}
                  />
                  <IconButton>
                    <Add onClick={this.addRequest} />
                  </IconButton>
                </div>
              </div>
              <div>
                <h4>Transfer Arrangements</h4>
                <Toggle
                  toggled={knownTransfers}
                  label={knownTransfers ? "Known" : "Unknown"}
                  labelPosition="right"
                  onClick={this.toggleKnownTransfers}
                />
                <TextField
                  floatingLabelText="Transfer Details"
                  value={transferArrangements}
                  onChange={this.updateTextField("transferArrangements")}
                  fullWidth
                />
                <div style={styles.transferDetails}>
                  <span>Arrival:</span>
                  <TextField
                    hintText={exampleArrival}
                    value={arrivalDetails}
                    onChange={this.updateTextField("arrivalDetails")}
                    fullWidth
                    disabled={!knownTransfers}
                  />
                </div>
                <div style={styles.transferDetails}>
                  <span>Departure:</span>
                  <TextField
                    hintText={exampleDeparture}
                    value={departureDetails}
                    onChange={this.updateTextField("departureDetails")}
                    fullWidth
                    disabled={!knownTransfers}
                  />
                </div>
              </div>
            </CardText>
          </Card>
          <Card style={renderedLetterStyles} id="renderedLetter">
            <CardText>
              <div style={styles.letterHeader}>
                <p>
                  <span style={styles.headerLabel}>{vendorName}</span>
                  <br />
                  <span style={styles.headerLabel}>From:</span>&nbsp;
                  <span>{inbox}</span>
                  <br />
                  <span style={styles.headerLabel}>
                    {amenityProgram} E-mail:
                  </span>
                  &nbsp;
                  <span>{primaryContactEmail}</span>
                  <br />
                  <span style={styles.headerLabel}>
                    Primary {amenityProgram} Contact:
                  </span>
                  &nbsp;
                  <span>
                    {primaryContactName} ({primaryContactPosition})
                  </span>
                  <br />
                  <span style={styles.headerLabel}>E-mail:</span>&nbsp;
                  <span>{displayEmailList}</span>
                  <br />
                  <span style={styles.headerLabel}>Gmail Link:</span>&nbsp;
                  <span>
                    <a
                      href={gmailLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      click here
                    </a>
                  </span>
                  <br />
                </p>
                <div>
                  <RaisedButton
                    label={vipDrafted ? "Mark Undrafted" : "Mark Drafted"}
                    onTouchTap={this.setCheckbox}
                    disabled={isDirty}
                    primary
                    style={{ marginRight: 15 }}
                  />
                  <RaisedButton
                    label="Save Changes"
                    onTouchTap={this.save}
                    disabled={!isDirty}
                    secondary
                  />
                </div>
              </div>
              <p>
                <b>Subject: </b>
                <span>{subjectLine}</span>
              </p>
              <VIPLetter {...vipLetterProps} />
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex"
  },
  leftColumn: {
    flex: "0 0 430px",
    marginLeft: 5
  },
  notesContainer: {
    overflow: "auto",
    position: "relative",
    width: 430
  },
  tripDetails: {
    background: "white",
    width: 430,
    zIndex: 10
  },
  rightColumn: {
    marginLeft: 5
  },
  headerLabel: {
    fontWeight: "bold"
  },
  formRow: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  letterHeader: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "baseline"
  },
  travelerName: {
    fontWeight: "bold"
  },
  form: {
    position: "fixed",
    maxHeight: "50%",
    overflow: "auto"
  },
  renderedLetter: {
    overflow: "auto",
    position: "fixed"
  },
  travelerRow: {},
  travelerChips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: 4
  },
  newRequest: {
    display: "flex"
  },
  formRequest: {
    display: "flex"
  },
  transferDetails: {
    display: "flex",
    alignItems: "baseline"
  },
  segmentIconStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    position: "relative",
    top: 5
  },
  indicatorGroupStyle: {
    display: "flex"
  },
  indicatorStyle: {
    // marginRight: 5,
    fontSize: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    width: 38,
    height: 33
  },
  cancelledIconStyle: {
    color: OurismanTravelTheme.palette.accent1Color
  },
  segmentListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    fontSize: 12
  },
  cancelledSegment: {
    textDecoration: "line-through",
    color: OurismanTravelTheme.palette.accent1Color
  },
  buttonStyle: {
    padding: 0,
    width: 20,
    height: 5,
    position: "relative",
    top: 8
  }
};

// eslint-disable-next-line no-shadow
const globalSelectorHandler = (selector, _, generateSubtreeStyles) => {
  if (selector[0] !== "*") {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};
const globalExtension = { selectorHandler: globalSelectorHandler };
const { StyleSheet: newStyleSheet, css: newCss } = StyleSheet.extend([
  globalExtension
]);

const aphroditeStyles = newStyleSheet.create({
  vipNotes: {
    margin: 5
  },
  display: {
    "*ul": {
      listStyleType: "disc",
      listStylePosition: "inside"
    },
    "*ol": {
      listStyleType: "decimal",
      listStylePosition: "inside"
    },
    "*em": {
      fontStyle: "italic"
    }
  }
});

export default SegmentDetail;



// WEBPACK FOOTER //
// /src/components/Segments/SegmentDetail.js